import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import logo from '../img/medsolutions.jpg';

export default function Obrigado() {
    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <section style={{ 
                backgroundColor: '#f4f5ff', 
                color: '#333', 
                padding: '100px 0' 
            }}>
                <Container>
                    <Row className="justify-content-center text-center">
                        <Col lg={8}>
                            <div style={{ marginBottom: '30px' }}>
                                <img 
                                    src={logo} 
                                    alt="MedSolutions" 
                                    style={{ 
                                        maxWidth: '300px', 
                                        height: 'auto'
                                    }}
                                />
                            </div>
                            <FontAwesomeIcon 
                                icon={faCheckCircle} 
                                size="4x" 
                                style={{ color: '#28a745', marginBottom: '30px' }}
                            />
                            <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#333' }}>
                                Contato Recebido!
                            </h1>
                            <p style={{ fontSize: '1.3rem', marginBottom: '30px', color: '#666' }}>
                                Obrigado pelo seu interesse no MedSolutions. 
                                Nossa equipe entrará em contato em breve.
                            </p>
                            <p style={{ fontSize: '1.1rem', marginBottom: '40px', color: '#666' }}>
                                Enquanto isso, que tal conhecer mais sobre nosso sistema?
                            </p>
                            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#667eea', 
                                        border: 'none',
                                        padding: '15px 30px',
                                        fontSize: '1.1rem'
                                    }}
                                    onClick={() => window.location.href = '/'}
                                >
                                    Voltar ao Site
                                </Button>
                                <Button 
                                    size="lg" 
                                    style={{ 
                                        backgroundColor: '#25d366', 
                                        border: 'none',
                                        padding: '15px 30px',
                                        fontSize: '1.1rem'
                                    }}
                                    onClick={() => window.open('https://wa.me/5532988495161?text=Ol%C3%A1,%20gostaria%20de%20saber%20mais%20sobre%20o%20MedSolutions', '_blank')}
                                >
                                    <FontAwesomeIcon icon={faWhatsapp} style={{ marginRight: '8px' }} />
                                    Falar no WhatsApp
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}